import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ErrorHandlingService } from '@shared/error-handling/error-handling.service';
import { Observable, tap } from 'rxjs';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  readonly #errorHandlingService = inject(ErrorHandlingService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        error: (error: HttpEvent<unknown>) => {
          if (error instanceof HttpErrorResponse) {
            this.#errorHandlingService.errorHandler(error);
          }
        }
      })
    );
  }
}
